<template>
  <div class="browse-background-slideshow">
    <div :id="carouselID" class="carousel slide" data-ride="carousel" data-interval="6000" data-pause="null">

        <ol class="carousel-indicators">
            <li :data-target="'#' + carouselID" data-slide-to="0" class="active"></li>
            <li :data-target="'#' + carouselID" data-slide-to="1"></li>
            <li :data-target="'#' + carouselID" data-slide-to="2"></li>
            <li :data-target="'#' + carouselID" data-slide-to="3"></li>
        </ol>

        <div class="carousel-inner" role="listbox">
          <div class="item active" id="item-1" :style="{backgroundImage: slideOne}">
            <div class="caption-box">
                <h1>{{ new Date().getFullYear() }} {{brandName}} Cars</h1>
                <p>Unparalleled performance</p>
                <a href="#" class="btn slide-btn" :style="buttonColor">Explore Cars</a>
            </div>
          </div>

          <div class="item" id="item-2" :style="{backgroundImage: slideThree}">
            <div class="caption-box">
                <h1>{{ new Date().getFullYear() }} {{brandName}} {{truckSlide}}</h1>
                <p>Built to work and play hard</p>
                <a href="#" class="btn slide-btn" :style="buttonColor">Explore {{truckSlide}}</a>
            </div>
          </div>

          <div class="item" id="item-3" :style="{backgroundImage: slideTwo}">
            <div class="caption-box">
                <h1>{{ new Date().getFullYear() }} {{brandName}} SUVs</h1>
                <p>Built for life's adventures</p>
                <a href="#" class="btn slide-btn" :style="buttonColor">Explore SUVs</a>
            </div>
          </div>

          <div class="item" id="item-4" :style="{backgroundImage: slideFour}">
            <div class="caption-box">
                <h1>Explore New Vehicles</h1>
                <p>Find the car of your dreams at Auto Dealer</p>
                <a href="#" class="btn slide-btn" :style="buttonColor">Explore New</a>
            </div>
          </div>
        </div>

        <a class="left carousel-control" :href="'#' + carouselID" role="button" data-slide="prev">
            <i class="fa fa-chevron-left" aria-hidden="true"></i>
            <span class="sr-only">Previous</span>
        </a>
        <a class="right carousel-control" :href="'#' + carouselID" role="button" data-slide="next">
            <i class="fa fa-chevron-right" aria-hidden="true"></i>
            <span class="sr-only">Next</span>
        </a>
    </div>
  </div>
</template>

<script>
import "../../static/bootstrap-3.3.7-dist/js/bootstrap.min.js";
import { mapGetters } from "vuex";

export default {
  props: ['images'],
  data() {
    return {
      brand: this.$store.state.chosenBrand,
      slideOne: 'url(' + this.images.lifestyleImages.sedanImage + ')',
      slideTwo: 'url(' + this.images.lifestyleImages.suvImage + ')',
      slideThree: 'url(' + this.images.lifestyleImages.truckImage + ')',
      slideFour: 'url(' + this.images.lifestyleImages.defaultImage + ')',
      carouselID: 'carousel-hero'
    }
  },
  computed: {
    ...mapGetters(["brandData"]),
    buttonColor () {
      if (this.brand === 'none') {
        return {'background-color': '#cc0000', 'color': '#fff'};
      } else if (this.brand === 'toyota' || this.brand === 'nissan' || this.brand === 'mitsubishi' || this.brand === 'honda' || this.brand === 'chevrolet') {
        return {'background-color': 'var(--primary-color)', 'color': '#fff'};
      } else if (this.brand === 'cjdr') {
        return {'background-color': 'var(--secondary-color)', 'color': '#fff'};
      } else {
        return {'backgroundColor': '#fff', 'color': 'var(--primary-dark)'};
      }
    },
    brandName () {
      if (this.brand === 'none') {
        return 'Brand';
      } else if (this.brand === 'infiniti' || this.brand === 'cjdr') {
        return this.brand.toUpperCase();
      } else {
        return this.brand.charAt(0).toUpperCase() + this.brand.slice(1);
      }
    },
    truckSlide () {
      if (this.images.trucks.length > 0) {
        return 'Trucks';
      } else {
        return 'SUVs';
      }
    }
  },
  mounted() {
    (function () {
      var slideCaption = {
        init: function () {
          var slideID = $(".browse-background-slideshow div:first-child").attr("id");
          var carouselContainer = $('#' + slideID);
          var slideInterval = 6000;

          function toggleC() {
              carouselContainer.find('.caption-box').hide()
              var caption = carouselContainer.find('.active').find('.caption-box').addClass('animated fadeInDown').one('webkitAnimationEnd mozAnimationEnd MSAnimationEnd oanimationend animationend',
                  function (){
                  $(this).removeClass('animated fadeInDown')});
              caption.slideToggle();
          }

          carouselContainer
            .carousel({
              interval: slideInterval,
              cycle: true
            })
            .on('slide.bs.carousel slid.bs.carousel', toggleC).trigger('slide.bs.carousel')
        }
      }
      $(document).ready(slideCaption.init);
    })(jQuery);
  }
};
</script>

<style
  scoped
  src="../../static/bootstrap-3.3.7-dist/css/bootstrap.min.css"
></style>

<style scoped>
  .browse-background-slideshow {
    width: 100%;
    position: relative;
    margin: auto;
    background: #000;
    font-family: Helvetica, Arial, sans-serif;
  }
  .browse-background-slideshow .caption-box {
    color: #fff;
    background: rgba(0, 0, 0, 0.85);
    font-size: 18px;
    padding: 30px 50px;
    position: absolute;
    top: 25px;
    left: 30px;
    height: 250px;
  }
  .browse-background-slideshow .slide-btn {
    color: #fff;
    background: var(--primary-color);
    font-size: 18px;
    text-transform: uppercase;
    padding: 6px 30px;
    margin: 15px auto;
    -webkit-transition: all 0.3s ease;
    -moz-transition: all 0.3s ease;
    -o-transition: all 0.3s ease;
    transition: all 0.3s ease;
  }
  .browse-background-slideshow .slide-btn:hover {
    opacity: .7;
  }
  .browse-background-slideshow .item {
    width: 100%;
    height: 500px;
    background-size: cover;
    background-position: center;
    background-position-y: 55%;
  }
  /*#item-1 {
    background-image: url(https://d2v1gjawtegg5z.cloudfront.net/uploads/files/000/043/952/original/20_FRD_MST_40830.png?1573766721);
    background-position-y: 70%;
  }
  #item-2 {
    background-image: url(https://d2v1gjawtegg5z.cloudfront.net/uploads/files/000/043/949/original/18_FRD_F15_40720_XLT.png?1573766720);
  }
  #item-3 {
    background-image: url(https://d2v1gjawtegg5z.cloudfront.net/uploads/files/000/043/951/original/20_FRD_EPR_400066.png?1573766721);
    background-position: bottom;
  }
  #item-4 {
    background-image: url(https://d2v1gjawtegg5z.cloudfront.net/uploads/files/000/043/950/original/20_FRD_EPD_47043_KRanch.png?1573766721);
    background-position-y: 70%;
  }*/
  .browse-background-slideshow .carousel-control {
    background-image: none;
    bottom: unset;
    top: 50%;
    font-size: 30px;
  }
  .browse-background-slideshow .carousel-inner>.item.next,
  .browse-background-slideshow .carousel-inner>.item.active.right {
    -webkit-transform: translate3d(100%, 0, 0) !important;
    transform: translate3d(100%, 0, 0) !important;
  }
  .browse-background-slideshow .carousel-indicators {
  left: 45%;
  max-width: 200px;
  margin-left: auto;
}
.browse-background-slideshow .carousel-inner .item {
  opacity: 0;
  transition-property: opacity;
}
.browse-background-slideshow .carousel-inner .active {
  opacity: 1;
}
.browse-background-slideshow .carousel-inner .active.left,
.browse-background-slideshow .carousel-inner .active.right {
  left: 0;
  opacity: 0;
  z-index: 1;
}
.browse-background-slideshow .carousel-inner .next.left,
.browse-background-slideshow .carousel-inner .prev.right {
  opacity: 1;
}
.browse-background-slideshow .carousel-control.left {
  display: none;
}
.browse-background-slideshow .carousel-control.left:focus {
  display: block;
}
.browse-background-slideshow .carousel-control.right {
  display: none;
}
.browse-background-slideshow .carousel-control.right:focus {
  display: block;
}
.browse-background-slideshow .carousel-control:focus > .glyphicon {
  outline: 5px auto -webkit-focus-ring-color;
  outline-offset: -2px;
}

@media all and (transform-3d), (-webkit-transform-3d) {
  .browse-background-slideshow .carousel-inner > .item.next,
  .browse-background-slideshow .carousel-inner > .item.active.right {
    opacity: 0;
    -webkit-transform: translate3d(0, 0, 0);
    transform: translate3d(0, 0, 0);
  }
  .browse-background-slideshow .carousel-inner > .item.prev,
  .browse-background-slideshow .carousel-inner > .item.active.left {
    opacity: 0;
    -webkit-transform: translate3d(0, 0, 0);
    transform: translate3d(0, 0, 0);
  }
  .browse-background-slideshow .carousel-inner > .item.next.left,
  .browse-background-slideshow .carousel-inner > .item.prev.right,
  .browse-background-slideshow .carousel-inner > .item.active {
    opacity: 1;
    -webkit-transform: translate3d(0, 0, 0);
    transform: translate3d(0, 0, 0);
  }
  .browse-background-slideshow .carousel-inner .left .caption-box, .browse-background-slideshow .carousel-inner .left .car-img-wrapper {
    display: none !important;
  }
}

  .browse-background-slideshow .caption-box {
    animation-delay: 0.1s;
    -webkit-animation-delay: 0.1s;
    -moz-animation-delay: 0.1s;
    -o-animation-delay: 0.1s;
    -moz-transition: none !important;
  }
  .animated {
    -webkit-animation-duration: .8s;
    animation-duration: .8s;
    -webkit-animation-fill-mode: both;
    animation-fill-mode: both;
  }

  @media(max-width: 767px) {
    .browse-background-slideshow .caption-box {
      background: rgba(0,0,0,.75);
      top: 30px;
      left: 15px;
      right: 15px;
      width: auto;
      height: 340px;
      padding: 15px 30px;
    }
    .browse-background-slideshow .item {
      height: 400px
    }
    .animated {
      -webkit-animation-duration: .1s;
      animation-duration: .1s;
      -webkit-animation-fill-mode: both;
      animation-fill-mode: both;
    }
    .browse-background-slideshow .carousel-indicators {
      display: none;
    }
  }

</style>